import { Header5, Paragraph4, Sucess16 as IconSuccess, Paragraph3 } from '@cian/ui-kit';
import classNames from 'classnames';

import * as React from 'react';

import * as styles from './styles.css';

interface IPreviewBlock {
  className?: string;
}

export const PreviewBlock: React.FC<IPreviewBlock> = ({ className }) => (
  <div className={classNames(styles['root'], className)}>
    <div className={styles['disabled-button']}>
      <Header5 color="white_100" textAlign="center" verticalAlign="middle">
        Показать телефон
      </Header5>
    </div>
    <div className={styles['lines']}>
      <div className={styles['placeholder']} />
      <div className={styles['placeholder']} />
    </div>
    <div className={styles['from-commercial-owner']}>
      <Paragraph4 color="success_100" fontWeight="bold">
        СОБСТВЕННИК
      </Paragraph4>
    </div>
    <div className={styles['rosreestr-verification']}>
      <IconSuccess color="primary_100" />
      <span className={styles['text']}>
        <Paragraph3>Проверено в Росреестре</Paragraph3>
      </span>
    </div>
  </div>
);

PreviewBlock.displayName = 'PreviewBlock';
